import { getClientLogoutUrl } from "@/config/clientLogout";
import { cn } from "@/lib/utils";

import ULThemeLink from "./ULThemeLink";

export interface ULThemeAccountSwitchProps {
  /** The account this login is for, from `useUser().email`. */
  email?: string | null;
  /** The application being signed into, from `useClient().id`. */
  clientId?: string | null;
  className?: string;
}

/**
 * "Signing in as x@y · Not you? Log out" for the MFA challenge screens.
 *
 * Without it a challenge screen names no account and offers no way out of
 * the half-finished login (see `config/clientLogout.ts`). When the context
 * carries no email the escape link still renders on its own: the way out is
 * the part that unblocks somebody.
 */
const ULThemeAccountSwitch = ({
  email,
  clientId,
  className,
}: ULThemeAccountSwitchProps) => {
  return (
    <p
      className={cn(
        "ul-account-switch mb-6 justify-text-header text-body-text text-(length:--ul-theme-font-body-text-size) break-words",
        className
      )}
      data-testid="account-switch"
    >
      {email && (
        <>
          Signing in as{" "}
          <span className="ul-account-switch__email font-semibold">
            {email}
          </span>
          .{" "}
        </>
      )}
      <ULThemeLink href={getClientLogoutUrl(clientId)}>
        {email ? "Not you? Log out" : "Use a different account"}
      </ULThemeLink>
    </p>
  );
};

export default ULThemeAccountSwitch;
